<div class="agenda">
  <div class="row-span-2 w-full h-full overflow-y-scroll p-4" style="max-height: calc(100vh - 135px)">
    <div class="flex justify-between items-center py-2">
      <div class="flex rounded-sm gap-4 items-center bg-alto-200 p-1 px-4">
        <span class="text-chathams-blue"
          >{{ primeiroDiaSemana | date : 'dd/MM/yyyy' }} à {{ ultimoDiaSemana | date : 'dd/MM/yyyy' }}</span
        >
        <button
          mwlCalendarPreviousView
          (viewDateChange)="carregarAgendamentos($event)"
          [view]="view"
          [(viewDate)]="viewDate"
          title="Semana Passada"
        >
          <img class="w-6 h-8" src="./assets/icons/arrow-left-circle-blue.svg" alt="arrow left" />
        </button>
        <button
          mwlCalendarNextView
          (viewDateChange)="carregarAgendamentos($event)"
          [view]="view"
          [(viewDate)]="viewDate"
          title="Próxima Semana"
        >
          <img class="w-6 h-8" src="./assets/icons/arrow-right-circle-blue.svg" alt="arrow right" />
        </button>
      </div>

      <select
        *ngIf="!isDoctor"
        class="w-60 form-select form-select-lg text-white font-medium bg-blumine"
        aria-label=".form-select-lg"
        [formControl]="doctorControl"
      >
        <option value="">Todos os Atendentes</option>
        <option *ngFor="let doctor of doctors" [value]="doctor.id">{{ doctor.name }}</option>
      </select>
    </div>

    <ng-container *ngIf="events$ | async; let events">
      <mwl-calendar-week-view
        [viewDate]="viewDate"
        [events]="events"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [weekendDays]="weekendDays"
        [precision]="'minutes'"
        [hourSegments]="4"
        [dayStartHour]="8"
        [dayEndHour]="22"
        [hourSegmentHeight]="35"
        [headerTemplate]="headerTemplate"
        [eventTemplate]="weekView"
        [currentTimeMarkerTemplate]="currentTimeMarkerTemplate"
        (hourSegmentClicked)="scheduleConsulta($event.date)"
      >
      </mwl-calendar-week-view>
      <ng-template #weekView let-weekEvent="weekEvent">
        <app-consulta-agenda
          [event]="weekEvent.event"
          (consultaChange)="showModalConsulta(weekEvent.event.id)"
          (entrarConsultaChange)="enterConsulta($event)"
        ></app-consulta-agenda>
      </ng-template>
      <ng-template #headerTemplate>
        <div
          class="w-full flex rounded-sm divide-x-2 divide-alto-400 border-2 border-alto-400 opacity-60 h-16 bg-alto-200"
        >
          <div class="h-full" style="width: 71.5px"></div>
          <div class="grid grid-cols-7 w-full divide-x-2 divide-alto-400">
            <app-agenda-header-dia
              *ngFor="let dia of this.diasSemana; let i = index"
              [index]="i"
              [numero]="dia"
              [selectedDate]="viewDate"
              [horas]="i > 0 || i < 6 ? 8 : 0"
            ></app-agenda-header-dia>
          </div>
        </div>
      </ng-template>
      <ng-template
        #currentTimeMarkerTemplate
        let-columnDate="columnDate"
        let-dayStartHour="dayStartHour"
        let-dayStartMinute="dayStartMinute"
        let-dayEndHour="dayEndHour"
        let-dayEndMinute="dayEndMinute"
        let-isVisible="isVisible"
        let-topPx="topPx"
      >
        <div
          class="cal-current-time-marker"
          *ngIf="isVisible"
          [style.top.px]="topPx"
          [style.left]="'calc( -' + currentDate.getDay() + ' * ((100vw - 440px) / 7) - 71.5px)'"
        ></div>
      </ng-template>
    </ng-container>
  </div>

  <div class="p-2 py-4 flex flex-col gap-4 items-center w-full overflow-y-auto" style="max-height: calc(100vh - 135px)">
    <app-calendar
      *ngIf="calendarEvents$ | async as calendarEvents"
      [date]="calendarDate"
      (monthSelection)="getConsultasCalendarioByData($event)"
      (dateSelection)="getAgendamentosByDate($event)"
      [events]="calendarEvents"
    ></app-calendar>

    <hr class="w-full" />

    <div class="p-4 legenda flex flex-col gap-2 w-11/12 h-full shadow bg-iceberg-600">
      <h3 class="text-chathams-blue font-bold">Consultas Agendadas do dia</h3>

      <app-proximas-consultas-dia
        *ngFor="let consulta of consultasDia"
        [consulta]="consulta"
        (entrarConsultaChange)="scheduleConsulta($event)"
      ></app-proximas-consultas-dia>

      <span *ngIf="consultasDia.length === 0">Nenhuma consulta agendada para hoje</span>
    </div>
  </div>
</div>
<app-consultas-modal
  *ngIf="showModalDetalhesConsulta"
  [consulta]="consulta"
  (appointmentAction)="hideModalConsulta()"
  (closeModal)="hideModalConsulta()"
>
</app-consultas-modal>

<app-marcar-consulta-modal
  *ngIf="showModalMarcarConsulta"
  [appointmentDate]="marcarConsultaDate!"
  (appointmentAction)="hideModalMarcarConsulta()"
  (closeModal)="hideModalMarcarConsulta()"
></app-marcar-consulta-modal>
